import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, RequestMethod } from "@angular/http";
import { Observable } from 'rxjs/Observable';
import { debug } from 'util';
import { Action, refundApprove } from '../Model/refundApprove';
import { chaseRefundProcessInput } from "../Model/chaseRefundProcessInput";
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class RefundApproveService {
  private baseUrl: string;
  RefundDetailID: any;
  constructor(private http: Http, private getEnvVarService: GetEnvVarService) {
   //this.baseUrl = "http://localhost:56375";
   //this.baseUrl = "https://Invoiceservice.devusz.nbcuni.com";
   //this.baseUrl = "https://InvoiceserviceQA.devusz.nbcuni.com";
   this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
    
  }

  //Method to get the Action List
  getActionList(): Observable<any[]> {
    //debugger;
    //return this.http.get("assets/data/InternalUser.json")
    return this.http.get(this.baseUrl + `/api/getActionList`)
      .map(response => response.json() as Action[])
      .catch(handleError);
  }

  //Method to get the Refund Details
  getRefundDetails(UserID): Observable<any[]> {
    debugger;
    //return this.http.get("assets/data/InternalUser.json")
    return this.http.get(this.baseUrl + `/api/getRefundDetails/`+UserID)
      .map(response => response.json() as any[])
      .catch(handleError);
  }

  submitActionDetails(updatedRefundDetails:any): Observable<any> {
    //debugger;

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.baseUrl + `/api/submitAction`, JSON.stringify(updatedRefundDetails), options)
    //return this.http.post(this.baseUrl + `/api/submitAction/`+ApprovalStatus+`/`+RefundApproved + `/`+comments+ );
      .map(response => response.json() as any); 
  }

  getChaseRefundStatus(chaseOrderId: string): Observable<any> {

  return this.http.get(this.baseUrl + `/api/getChaseRefundStatus/` + chaseOrderId)
      .map(response => response.json() as any)
      .catch(handleError);
}

  postRefund(dataXML : string) {

    var body = dataXML;
    var headerOptions = new Headers({'Content-Type':'application/PTI70'});
    headerOptions.append('mime-version','1.0');
    headerOptions.append('Content-transfer-encoding','text');
    headerOptions.append('Request-number','1');
    headerOptions.append('Document-type','Request');
    headerOptions.append('Access-Control-Allow-Methods','GET, POST, OPTIONS');
    headerOptions.append('Access-Control-Allow-Headers','Content-Type, Accept');
    headerOptions.append("Access-Control-Max-Age", "1728000");
    headerOptions.append('Cache-Control','no-cache');
    headerOptions.append('Access-Control-Allow-Origin', '*');
    var requestOptions = new RequestOptions({method : RequestMethod.Post,headers : headerOptions});
    return this.http.post('https://orbitalvar2.chasepaymentech.com/authorize',body,requestOptions).map(data => {
      let result = data["_body"]; 
      return result;}
      , error => {
        let result= error.text();
        console.log("ERROR: ", error);
      return result;
      }
    );

  }

getChaseRefundRequestData(refundDetailId: string): Observable<any> {

  return this.http.get(this.baseUrl + `/api/getChaseRefundRequestData/` + refundDetailId)
      .map(response => response.json() as any)
      .catch(handleError);

}  

processChaseRefundResponse(refundDetailId: string, processInput: chaseRefundProcessInput): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });
  return this.http.post(this.baseUrl + `/api/processChaseRefundResponse/` + refundDetailId, JSON.stringify(processInput), options )
  .map(response => response.json());

} 

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}


// WEBPACK FOOTER //
// ./src/app/refund-approve/Service/refund-approve.service.ts